/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Department from './department';
import DepartmentDetail from './department-detail';
import DepartmentUpdate from './department-update';
import DepartmentDeleteDialog from './department-delete-dialog';

const DepartmentRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Department />} />
    <Route path="new" element={<DepartmentUpdate />} />
    <Route path=":id">
      <Route index element={<DepartmentDetail />} />
      <Route path="edit" element={<DepartmentUpdate />} />
      <Route path="delete" element={<DepartmentDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default DepartmentRoutes;
